function AppDevelopment() {
    return (
        <div>
            <div class="app-development wow fadeIn" style={{ marginTop: "5.2%" }}>
                <section class="banner_wrapper wow fadeIn" style={{ visibility: "visible" }} >
                    {/* <!-- id="module" --> */}
                    <div id="element2"> </div>
                    <div class="container">
                        <div class="Banner_content">
                            <div class="Bnr_left bnr-cmn">
                                <div class="hero_text">
                                    <h1 data-aos="zoom-in"
                                        data-aos-duration="300"
                                        data-aos-easing="ease-in-sine">App Development</h1>
                                </div>
                                {/* <!-- cd-intro --> */}
                                <p data-aos="fade-up"
                                    data-aos-duration="1000"
                                    data-aos-easing="ease-in-sine">We Help You Develop Applications That Will Help Customers Associate Better And Widen Your Reach Over The Internet.
                                </p>
                            </div>
                        </div>
                    </div>

                </section>
                <section class="Our-Service_wrapper AppConten_wrp wow fadeIn" style={{ visibility: "visible" }}>
                    <div class="container">
                        <div class="Srv-heading">
                            <h2 data-aos="zoom-in"
                                data-aos-duration="300"
                                data-aos-easing="ease-in-sine">Bring Your Business Fully Accessible In Smartphones</h2>
                            <p data-aos="fade-up"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-sine">In the era of smartphones, apps are exclusive weapons helping to improve the efficiency of any organization. We help you develop applications that will help customers interact better and improve your reach over the internet. We provide top-notch app development services for clients all over the globe that satisfy their intent completely. When you are running a business online you need to find different ways to interact with your customers and nothing is better than a well-performing application.
                            </p>
                        </div>
                        <div class="App_cnt Android_app">
                            <div class="left_app1 left-cmn01" data-tilt data-tilt-glare data-tilt-max-glare="0.8">
                                <figure data-aos="fade-right"
                                    data-aos-duration="300"
                                    data-aos-easing="ease-in-sine">
                                    <img src="image/android1.gif" alt="img" />
                                </figure>
                            </div>
                            <div class="right_app1 left-cmn01">
                                <h2 data-aos="fade-left"
                                    data-aos-duration="900"
                                    data-aos-easing="ease-in-sine">Android App Development</h2>
                                <p data-aos="fade-left"
                                    data-aos-duration="1000"
                                    data-aos-easing="ease-in-sine">We Are The Leaders In Android App Development Presenting The Best In The Class Apps.
                                </p>
                                {/* <!-- <a data-aos="fade-left"
                                    data-aos-duration="1600"
                                    data-aos-easing="ease-in-sine" href="android.html" class="hvr-bounce-to-right">learn more</a> --> */}
                            </div>
                        </div>
                        <div class="App_cnt Ios_app">
                            <div class="left_app1 left-cmn01" data-tilt data-tilt-glare data-tilt-max-glare="0.8">
                                <figure data-aos="fade-left"
                                    data-aos-duration="300"
                                    data-aos-easing="ease-in-sine">
                                    <img src="image/ios.gif" alt="img" />
                                </figure>
                            </div>
                            <div class="right_app1 left-cmn01">
                                <h2 data-aos="fade-right"
                                    data-aos-duration="800"
                                    data-aos-easing="ease-in-sine">Ios App Development</h2>
                                <p data-aos="fade-right"
                                    data-aos-duration="1000"
                                    data-aos-easing="ease-in-sine">When It Comes To IOS App Development No One Can Match The Level Of Expertise We Have Achieved.
                                </p>
                                {/* <!-- <a data-aos="fade-right"
                                    data-aos-duration="1600"
                                    data-aos-easing="ease-in-sine" href="ios.html" class="hvr-bounce-to-right">learn more</a> --> */}
                            </div>
                        </div>
                        <div class="App_cnt hybrid_app">
                            <div class="left_app1 left-cmn01" data-tilt data-tilt-glare data-tilt-max-glare="0.8">
                                <figure data-aos="fade-right"
                                    data-aos-duration="300"
                                    data-aos-easing="ease-in-sine">
                                    <img src="image/hybrid2.gif" alt="img" />
                                </figure>
                            </div>
                            <div class="right_app1 left-cmn01">
                                <h2 data-aos="fade-left"
                                    data-aos-duration="800"
                                    data-aos-easing="ease-in-sine">hybrid App Development</h2>
                                <p data-aos="fade-left"
                                    data-aos-duration="1000"
                                    data-aos-easing="ease-in-sine">Tech DH Consist Of A Talented And Skilled Team Of Hybrid App Developers. They Can Work Intensively For You To Develop.
                                </p>
                                {/* <!-- <a data-aos="fade-left"
                                    data-aos-duration="1600"
                                    data-aos-easing="ease-in-sine" href="hybrid.html" class="hvr-bounce-to-right">learn more</a> --> */}
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>
    )
}

export default AppDevelopment;